import React, { useContext } from "react";
import { FirebaseProvider, FirebaseContext } from "./contexts/FirebaseContext";
import { SessionProvider } from "./contexts/SessionContext";
import { CommonUIProvider } from "./contexts/CommonUIContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LocalFileActionsProvider } from "./contexts/LocalFileActionsContext";
import { RemoteFileActionsProvider } from "./contexts/RemoteFileActionsContext";
import { OpenAIChatProvider } from "./contexts/OpenAIChatContext";
import { ImageSelectorProvider } from "./contexts/ImageSelectorContext";
import { GlobalNetworkStateProvider } from "./contexts/GlobalNetworkStateContext";
import { RemoteGitActionsProvider } from "./contexts/RemoteGitActionsContext";
import { TestEndpointsProvider } from "./contexts/TestEndpointsContext";
import { IDEProvider } from "./contexts/IDEContext";
import GlobalNetworkStateDialog from "./components/GlobalNetworkStateDialog";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";
import WipScreen from "./screens/WipScreen";
import SparkScreen from "./screens/SparkScreen";
import StatsScreen from "./screens/StatsScreen";
import SearchScreen from "./screens/SearchScreen";
import PlaceholderScreen from "./screens/PlaceholderScreen";
import SettingsScreen from "./screens/SettingsScreen";
import RecurringScreen from "./screens/RecurringScreen";
import RuleDetailScreen from "./screens/RuleDetailScreen";
import CodeScreen from "./screens/CodeScreen";
import AuthScreen from "./screens/AuthScreen";
import ProjectDetailScreen from "./screens/ProjectDetailScreen";
import TaskDetailScreen from "./screens/TaskDetailScreen";
import NoteDetailScreen from "./screens/NoteDetailScreen";
import InvoiceListScreen from "./screens/InvoiceListScreen";
import InvoiceFormScreen from "./screens/InvoiceFormScreen";
import InvoicePreviewScreen from "./screens/InvoicePreviewScreen";
import InvoiceSettingsScreen from "./screens/InvoiceSettingsScreen";
import ClientsScreen from "./screens/ClientsScreen";
import MainAppContainer from "./components/MainAppContainer";

const App = () => {
  const { currentUser, authLoading } = useContext(FirebaseContext);

  if (authLoading) {
    return <div>Auth Loading...</div>;
  }

  return (
    <Router>
      {currentUser ? (
        <MainAppContainer>
          <GlobalNetworkStateDialog />
          <Routes>
            <Route path="/home" element={<HomeScreen />} />
            <Route path="/wip" element={<WipScreen />} />
            <Route path="/spark" element={<SparkScreen />} />
            <Route path="/stats" element={<StatsScreen />} />
            <Route path="/search" element={<SearchScreen />} />
            <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/recurring" element={<RecurringScreen />} />
        <Route path="/recurringDetail/:ruleId" element={<RuleDetailScreen />} />
            <Route path="/code" element={<CodeScreen />} />
            <Route
              path="/projectDetail/:projectId"
              element={<ProjectDetailScreen />}
            />
            <Route path="/taskDetail/:taskId" element={<TaskDetailScreen />} />
            <Route path="/noteDetail/:noteId" element={<NoteDetailScreen />} />
            <Route path="/invoice" element={<InvoiceListScreen />} />
            <Route path="/invoiceDetail/:invoiceId" element={<InvoiceFormScreen />} />
            <Route path="/invoicePreview/:invoiceId" element={<InvoicePreviewScreen />} />
            <Route path="/invoiceSettings" element={<InvoiceSettingsScreen />} />
            <Route path="/clients" element={<ClientsScreen />} />
            {/* Not-yet-built bottom-bar tabs (Recurring/Chat/Stats/Invoice). */}
            <Route path="/soon/:feature" element={<PlaceholderScreen />} />
            <Route path="*" element={<Navigate to="/home" />} />
          </Routes>
        </MainAppContainer>
      ) : (
        <Routes>
          <Route path="/auth" element={<AuthScreen />} />
          <Route path="*" element={<Navigate to="/auth" />} />
        </Routes>
      )}
    </Router>
  );
};

const AppWrapper = () => (
  <ThemeProvider>
  <IDEProvider>
    <TestEndpointsProvider>
      <CommonUIProvider>
        <GlobalNetworkStateProvider>
          <FirebaseProvider>
            <SessionProvider>
              <RemoteGitActionsProvider>
                <RemoteFileActionsProvider>
                  <LocalFileActionsProvider>
                    <ImageSelectorProvider>
                      <OpenAIChatProvider>
                        <App />
                      </OpenAIChatProvider>
                    </ImageSelectorProvider>
                  </LocalFileActionsProvider>
                </RemoteFileActionsProvider>
              </RemoteGitActionsProvider>
            </SessionProvider>
          </FirebaseProvider>
        </GlobalNetworkStateProvider>
      </CommonUIProvider>
    </TestEndpointsProvider>
  </IDEProvider>
  </ThemeProvider>
);

export default AppWrapper;
